import { render, staticRenderFns } from "./TrocaSenha.vue?vue&type=template&id=358cb863"
import script from "./TrocaSenha.vue?vue&type=script&lang=js"
export * from "./TrocaSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports